import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'
import React, { useContext } from 'react'

import colorContext from '../../Context/colorContext'

interface StepIndicatorProps {
  currentStep: number
  totalSteps: number
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'center',
  },
  stepDot: {
    borderRadius: '50%',
    transition: 'all 0.3s ease',
  },
}))

export default function StepIndicator({
  currentStep,
  totalSteps,
}: StepIndicatorProps): JSX.Element {
  const classes = useStyles()
  const { colors } = useContext(colorContext)

  return (
    <Box className={classes.container}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1
        const isActive = stepNumber === currentStep
        const isCompleted = stepNumber < currentStep

        return (
          <Box
            key={stepNumber}
            className={classes.stepDot}
            style={{
              width: isActive ? '15px' : '10px',
              height: isActive ? '15px' : '10px',
              backgroundColor:
                isActive || isCompleted ? colors.accentColor : '#D1D5DB',
              border: isActive ? '3px solid #C0D9ED' : 'none',
            }}
          />
        )
      })}
    </Box>
  )
}
